import { connect } from 'react-redux';
import type { Props } from '../components/StabilityAndGrowthOfPayments';
import StabilityAndGrowthOfPayments from '../components/StabilityAndGrowthOfPayments';
import { getStabilityAndGrowthOfPaymentsSelector } from '../redux/selectors';
import {
  getDividendSeries,
  getCurrencyISOCode,
  getFrequency,
  getYieldSeries,
  getDPSSeries,
  getMinMax,
} from './utils';
import type { DivPaymentDetailRawData } from '../hooks/types';

/** @TODO: let's kill this container */
const mapStateToProps = (state, ownProps): Props => {
  const stabilityAndGrowthOfPayments = getStabilityAndGrowthOfPaymentsSelector(
    state,
    ownProps
  );
  const rate = 1;

  const divPaymentDetailRawData =
    ownProps.divPaymentDetailData as DivPaymentDetailRawData;

  const divPaymentDetailCurrencyISO = getCurrencyISOCode(
    divPaymentDetailRawData
  );
  const divPaymentDetailFreq = getFrequency(divPaymentDetailRawData);
  const dividendSeries = getDividendSeries(divPaymentDetailRawData, rate);
  const dividendMinMax = getMinMax(
    dividendSeries,
    stabilityAndGrowthOfPayments.DPSMax,
    stabilityAndGrowthOfPayments.DPSMin
  );
  const dividendYieldSeries = getYieldSeries(divPaymentDetailRawData);
  const dividendYieldMinMax = getMinMax(
    dividendYieldSeries,
    stabilityAndGrowthOfPayments.dividendYieldMax,
    stabilityAndGrowthOfPayments.dividendYieldMin
  );
  const dpsSeries = getDPSSeries(divPaymentDetailRawData);
  const dpsSeriesMinMax = getMinMax(
    dpsSeries,
    stabilityAndGrowthOfPayments.DPSMax,
    stabilityAndGrowthOfPayments.DPSMin
  );

  return {
    DPS: [...dpsSeries, ...stabilityAndGrowthOfPayments.DPS],
    DPSMax: dpsSeriesMinMax.max,
    DPSMin: dpsSeriesMinMax.min,
    EPS: stabilityAndGrowthOfPayments.EPS,
    EPSMax: stabilityAndGrowthOfPayments.EPSMax,
    EPSMin: stabilityAndGrowthOfPayments.EPSMin,
    currencyISO: stabilityAndGrowthOfPayments.currencyISO,
    dayZero: stabilityAndGrowthOfPayments.dayZero,
    dividendYield: [
      ...dividendYieldSeries,
      ...stabilityAndGrowthOfPayments.dividendYield,
    ],
    dividendYieldMax: dividendYieldMinMax.max,
    dividendYieldMin: dividendYieldMinMax.min,
    divPaymentDetailSeriesData: dividendSeries,
    divPaymentDetailMin: dividendMinMax.min,
    divPaymentDetailMax: dividendMinMax.max,
    divPaymentDetailCurrencyISO,
    divPaymentDetailFreq,
    dateFormatter: ownProps.dateFormatter,
    labels: ownProps.labels,
  };
};

export default connect(mapStateToProps)(StabilityAndGrowthOfPayments);
